import { LoadingButton } from '@mui/lab'
import { Autocomplete, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuthContext } from 'src/auth/useAuthContext'
import CustomInput from 'src/components/customerinput/CustomerInput'
import CustomModal from 'src/components/customerinput/CustomModal'
import { notify } from 'src/components/notify'
import { createPosDevices } from 'src/services/pos'

export default function AddDevice({ open, close, id, editData, setReload, setPage, vendors = [] }) {
    const { user } = useAuthContext()
    const [values, setValues] = useState({
        deviceId: "",
        name: "",
        display_name: "",
        status: "true",
        store_id: ""
    })
    const [vendorId, setVendorId] = useState({ _id: "", name: "" })

    const handleSubmit = async () => {
        try {
            if (!values.deviceId.trim()) {
                return notify("Device Id is required.")
            }
            if (!vendorId?._id.trim()) {
                return notify("Vendor is required.")
            }
            if (!values.name.trim()) {
                return notify("Device Name is required.")
            }
            if (!values.display_name.trim()) {
                return notify("Display Name is required.")
            }
            let data = {
                ...values,
                vendor: vendorId?._id
            }
            if (editData) {
                data = {
                    ...data,
                    status: values.status == "false" ? false : true,
                }
            }

            const method = editData ? "put" : "post"
            const url = editData ? "/service/accounts_service/v1/accounts/pos/update" : "/service/accounts_service/v1/accounts/pos/add"
            const response = await createPosDevices(user, data, method, url,)

            if (response) {
                setPage(0)
                setReload((prev) => !prev)
                close()
                if (editData) {
                    notify("Device Update Successfully", "success")
                } else {
                    notify("Device Successfully added", "success")
                }
            }

        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        if (editData) {
            setValues({
                deviceId: editData?.deviceId,
                name: editData?.name,
                status: String(editData?.status),
                id: editData?._id,
                display_name: editData?.display_name,
                store_id: editData?.store_id || "",
            })
            if (editData?.vendor) {
                setVendorId({ _id: editData?.vendor?.id, name: editData?.vendor?.name })
            }
        }
    }, [editData])
    return (
        <div>
            <CustomModal heading={editData ? "Update Device" : "Add Device"} open={open} close={close} action={<LoadingButton variant="contained" onClick={handleSubmit}>{editData ? "Update" : "Create"}</LoadingButton>}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Stack spacing={1} sx={{ width: "100%" }}>
                            <Typography>Select Partner</Typography>
                            <Autocomplete
                                id="checkboxes-tags-demo"
                                options={[...vendors]}
                                limitTags={2}
                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => option._id === value._id}
                                renderOption={(props, option, { selected }) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                        <li key={key} {...optionProps}>
                                            {option.name}
                                        </li>
                                    );
                                }}
                                value={vendorId}
                                onChange={(_, val) => {
                                    setPage(0)
                                    setVendorId(val)
                                }}

                                sx={{ width: "100%" }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Partners"
                                        placeholder="Select Partners" />
                                )}
                            />
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput
                            label="Display Name"
                            input={
                                <TextField fullWidth placeholder="Enter Device Name."
                                    onChange={(e) => setValues((prev) => {
                                        return {
                                            ...prev,
                                            display_name: e.target.value
                                        }
                                    })}
                                    value={values.display_name}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput
                            label="Device Name"
                            input={
                                <TextField fullWidth placeholder="Enter Device Name."
                                    onChange={(e) => setValues((prev) => {
                                        return {
                                            ...prev,
                                            name: e.target.value
                                        }
                                    })}
                                    value={values.name}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput
                            label="Device ID"
                            input={
                                <TextField fullWidth placeholder="Enter Device ID."
                                    helperText="Pine Labs ClientId of the terminal"
                                    onChange={(e) => {
                                        const numericValue = e.target.value.replace(/\D/g, '');
                                        setValues((prev) => {
                                            return {
                                                ...prev,
                                                deviceId: numericValue
                                            }
                                        })
                                    }}
                                    value={values.deviceId}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput
                            label="Store ID"
                            input={
                                <TextField fullWidth placeholder="Enter Store ID."
                                    onChange={(e) => {
                                        const numericValue = e.target.value.replace(/\D/g, '');
                                        setValues((prev) => {
                                            return {
                                                ...prev,
                                                store_id: numericValue
                                            }
                                        })
                                    }}
                                    value={values.store_id}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl>
                            <Typography>Status</Typography>
                            <RadioGroup
                                row
                                onChange={(e) => setValues((prev) => {
                                    return {
                                        ...prev,
                                        status: e.target.value
                                    }
                                })}
                                value={values.status}
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <FormControlLabel value="true" control={<Radio />} label="Active" />
                                <FormControlLabel value="false" control={<Radio />} label="In Active" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>

            </CustomModal>
        </div>
    )
}
